import { render, staticRenderFns } from "./NotaryProgressIndicator.vue?vue&type=template&id=445c8c7c&scoped=true&"
import script from "./NotaryProgressIndicator.vue?vue&type=script&lang=js&"
export * from "./NotaryProgressIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c8c7c",
  null
  
)

export default component.exports